import React from "react";

export const SectionHeader = ({ overline, title, lead, align = "left", testId }) => {
  return (
    <div
      data-testid={testId}
      className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}
    >
      {overline && <div className="overline mb-4">{overline}</div>}
      {title && (
        <h2 className="font-display text-3xl sm:text-4xl lg:text-[44px] font-bold tracking-tight text-navy leading-[1.1]">
          {title}
        </h2>
      )}
      {lead && (
        <p className="mt-5 text-[17px] leading-relaxed text-charcoal">
          {lead}
        </p>
      )}
    </div>
  );
};

export const Card = ({ icon: Icon, title, children, testId, className = "" }) => {
  return (
    <div
      data-testid={testId}
      className={`group hover-lift bg-white border border-border rounded-md p-8 ${className}`}
    >
      {Icon && (
        <div className="inline-flex items-center justify-center h-11 w-11 rounded-md bg-navy/[0.04] text-navy mb-6 transition-colors group-hover:bg-navy group-hover:text-white">
          <Icon className="h-5 w-5" strokeWidth={1.5} />
        </div>
      )}
      {title && (
        <h3 className="font-display text-[19px] font-semibold text-navy tracking-tight">
          {title}
        </h3>
      )}
      {children && (
        <div className="mt-3 text-[15px] leading-relaxed text-charcoal">
          {children}
        </div>
      )}
    </div>
  );
};

export const PrincipleChip = ({ label, testId }) => (
  <div
    data-testid={testId}
    className="hover-lift bg-white border border-border rounded-md p-6 flex items-start gap-4"
  >
    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-warm shrink-0" />
    <span className="text-[15px] font-medium text-navy">{label}</span>
  </div>
);

export const ComplianceBand = ({ children, overline = "Compliance", testId = "compliance-band" }) => (
  <div
    data-testid={testId}
    className="border-y border-border bg-soft"
  >
    <div className="container-tight py-12 md:py-16">
      <div className="max-w-3xl">
        <div className="overline mb-3">{overline}</div>
        <p className="text-[16px] leading-relaxed text-charcoal">{children}</p>
      </div>
    </div>
  </div>
);
